import { useWarRoomStore } from '../stores/warRoomStore'
import { useActiveAlerts, useCriticalAlerts, useUnreadAlertCount } from '../stores/selectors'
import type { AIAlert } from '../types/event.types'

export interface AIAlertsState {
  alerts: AIAlert[]
  critical: AIAlert[]
  unreadCount: number
  hasCritical: boolean
  dismiss: (alertId: string) => void
  dismissAll: () => void
}

/**
 * Aggregates alert state for display components.
 * No API calls — alerts come from WebSocket events via Zustand.
 */
export function useAIAlerts(): AIAlertsState {
  const alerts = useActiveAlerts()
  const critical = useCriticalAlerts()
  const unreadCount = useUnreadAlertCount()
  const dismiss = useWarRoomStore((s) => s.dismissAlert)
  const dismissAll = useWarRoomStore((s) => s.dismissAllAlerts)

  return {
    alerts,
    critical,
    unreadCount,
    hasCritical: critical.length > 0,
    dismiss,
    dismissAll,
  }
}
